import React from 'react';
import PropTypes from 'prop-types';
import "./input.scss";

const TextInput = ({ name, label, onChange, placeholder, value, error, disabled = false, refersTo = null, className = '', onFocus, onBlur }) => {
	let wrapperClass = 'form-group';
	if (error && error.length > 0) {
		wrapperClass += " " + "has-error";
	}

	return (
		<div className={wrapperClass + " " + className} >
			<label htmlFor={name}>{label}</label>
			<div className="field">
				<input
					type="text"
					name={name}
					id={name}
					className={(error ? " form-control error " : " form-control ") + className }
					placeholder={placeholder}
					value={value}
					onChange={onChange}
					onFocus={onFocus}
					onBlur={onBlur}
					disabled={disabled ? "disabled" : ""}
					ref={refersTo} />
				{error && <div className="alert alert-danger">{error}</div>}
			</div>
		</div>
	);
};

TextInput.propTypes = {
	name: PropTypes.string,
	label: PropTypes.string,
	onChange: PropTypes.func,
	placeholder: PropTypes.string,
	value: PropTypes.string,
	error: PropTypes.string,
	refersTo: PropTypes.func,
	onBlur: PropTypes.func,
	onFocus: PropTypes.func
}

export default TextInput;


// WEBPACK FOOTER //
// ./src/components/common/TextInput.js